import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bd9f40c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "tabs-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", {
      class: "tabs-list",
      style: _normalizeStyle({ maxWidth: $setup.tabsListMaxWidth })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["tabs-item", { 'tabs-item-active': tab.id === $setup.activeTabId }]),
          key: tab.id,
          onClick: ($event: any) => ($setup.activeTabId = tab.id)
        }, _toDisplayString(tab.name), 11, _hoisted_2))
      }), 128))
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, $setup.activeTabSlotName, {}, undefined, true)
    ])
  ]))
}